import { getConfigForImportedTest, getConfigForMeasuredTest, getConfigForTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { FormatTypes } from 'Lib/Format';
import { getMoistureContentPercent } from '../../../MoistureContentWorksheet/Astm/Config/index';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      ...getConfigForMeasuredTest(
        qestIds.moistureContent.ASTM_D_2216.rev2019,
        'data.Preparation.AssociatedAsReceivedWaterContent'
      ),
      ...getConfigForImportedTest(
        qestIds.moistureContent.ASTM_D_2216.rev2019,
        'data.Preparation.AssociatedAsReceivedWaterContent'
      ),
      ...getMoistureContentPercent(
        'AsReceivedWaterContent',
        `${prefix}.Preparation`,
        'AssociatedAsReceivedWaterContentPreparationMethod'
      ),

      [`${prefix}.Preparation.AssociatedAsReceivedWaterContent.ExternalTest.Results.MoistureContentPercent`]: {
        format: { nearest: 0.1 },
      },

      [`${prefix}.LiquidLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.LiquidLimit`]: { format: { nearest: 0.1 } },
      ...getConfigForTest(qestIds.moistureContent.ASTM_D_2216.rev2019, 'data.LiquidLimit.Trials.MoistureDetermination'),

      [`${prefix}.LiquidLimitOvenDried.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimitOvenDried.Trials.LiquidLimit`]: { format: { nearest: 0.1 } },
      ...getConfigForTest(
        qestIds.moistureContent.ASTM_D_2216.rev2019,
        'data.LiquidLimitOvenDried.Trials.MoistureDetermination'
      ),

      [`${prefix}.PlasticLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.Results.LiquidLimit`]: { format: { nearest: 0.1 } },
      ...getConfigForTest(
        qestIds.moistureContent.ASTM_D_2216.rev2019,
        'data.PlasticLimit.Trials.MoistureDetermination'
      ),

      [`${prefix}.Results.LiquidLimitOvenDried`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.LiquidLimitRatio`]: { format: { nearest: 0.001 } },
      [`${prefix}.Results.PlasticLimit`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.ContainsOrganicMaterial`]: { format: { type: FormatTypes.YesNo } },
    },
    getMeasuredUsingConfig(prefix),
    {
      [`${prefix}.PlasticLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.PlasticLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimitOvenDried.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimitOvenDried.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
    }
  );

export default {
  [qestIds.atterbergLimit.ASTM_D_4318.methodA_Rev2017]: getConfig,
  [qestIds.atterbergLimit.ASTM_D_4318.methodB_Rev2017]: getConfig,
};
